export default __webpack_public_path__ + "static/media/filter-arrow-svg.c2ede6e6.svg";